import React, { memo } from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'
import { getAppDisplayName } from '@/utils/appBrand'

interface PropsType {
  text?: string
}
const BottomStatement = ({ text }: PropsType) => {
  const { t } = useTranslation()

  return (
    <div className="cmp-bottom-statement" >
      {t(text || 'Common.Statement', { APP: getAppDisplayName() })}
    </div >
  )
}

export default memo(BottomStatement)
